/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MainEditor.vue?vue&type=template&id=68583572&"
import script from "./MainEditor.vue?vue&type=script&lang=js&"
export * from "./MainEditor.vue?vue&type=script&lang=js&"
import style0 from "./MainEditor.vue?vue&type=style&index=0&id=68583572&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports